import { TranslateModule } from '@ngx-translate/core';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberToTimePipeModule } from 'src/app/pipes/number-to-time.pipe';
import { CirclePercentMarkerComponent } from './circle-percent-marker.component';



@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NumberToTimePipeModule
  ],
  exports: [CirclePercentMarkerComponent],
  declarations: [CirclePercentMarkerComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class CirclePercentMarkerComponentModule {}
